import React from 'react';
import { GlobalStyles, PaperOwnProps, PaperProps } from '@mui/material';
import { BottomDialog, IBottomDialogProps } from 'lib/BottomDialog';
import { useResponsive } from 'src/hooks/useResponsive';

const globalStyles = (
    <GlobalStyles
        styles={{
            '.global-blur': {
                filter: 'blur(1px)',
                opacity: 0.75
            }
        }}
    />
);

interface BaseModalProps extends React.PropsWithChildren<IBottomDialogProps> {
    paperSx?: PaperOwnProps['sx'];
    paperProps?: Omit<PaperProps, 'sx'>;
}

export const BaseModal: React.FC<BaseModalProps> = ({ paperSx = {}, paperProps = {}, ...props }) => {
    const { isDesktop } = useResponsive();
    React.useEffect(() => {
        const removeBlur = () => {
            const doc = document.getElementById('root');
            if (doc) {
                doc.classList.remove('global-blur');
            }
        };
        if (props.open) {
            const doc = document.getElementById('root');
            if (doc) {
                doc.classList.add('global-blur');
            }
        } else {
            removeBlur();
        }
        return () => removeBlur();
    }, [props.open]);

    return (
        <>
            {globalStyles}
            <BottomDialog
                paperProps={{
                    ...paperProps,
                    sx: {
                        borderBottomLeftRadius: isDesktop ? undefined : 0,
                        borderBottomRightRadius: isDesktop ? undefined : 0,
                        borderTopLeftRadius: props.fullScreen ? 0 : undefined,
                        borderTopRightRadius: props.fullScreen ? 0 : undefined,
                        ...paperSx
                    }
                }}
                {...props}
            />
        </>
    );
};
